import TiptapLink from "@tiptap/extension-link"
import TiptapTypography from "@tiptap/extension-typography"
import StarterKit from "@tiptap/starter-kit"
import { Highlight } from "./extensions/highlight.js"
import { TextAlign } from "./extensions/textAlign.js"
import { Blockquote } from "./nodes/blockquoteNode.js"
import { ImageNode } from "./nodes/imageNode.js"

/**
 * This file exists because the refractor dependency can't be used in
 * a web worker. We load extensions in the sync worker since we transform
 * the content into text.
 */
type Options = {
  dropcursor: Record<string, any> | false
}
export function extensionsWithoutRefractor(options: Options): any {
  return [
    StarterKit.configure({
      heading: {
        levels: [1, 2, 3],
      },
      codeBlock: false,
      blockquote: false,
      dropcursor: options.dropcursor,
    }),
    Highlight,
    Blockquote,
    TiptapTypography,
    TiptapLink.configure({ openOnClick: "whenNotEditable" }),
    ImageNode,
    TextAlign.configure({
      types: ["paragraph", "heading"],
    }),
  ]
}
